export default __webpack_public_path__ + "static/media/rolesDelete.59ea1472.svg";